import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { AlertController } from 'ionic-angular';

import { Camera, CameraOptions } from '@ionic-native/camera';
import { GoogleCloudVisionServiceProvider } from '../../providers/google-cloud-vision-service/google-cloud-vision-service';
import { ScansHistoryProvider } from '../../providers/scans-history/scans-history';



@IonicPage()
@Component({
  selector: 'page-anpr',
  templateUrl: 'anpr.html',
})
export class AnprPage {
  anprRes: string;
  picture: any;
  constructor(public navCtrl: NavController, public navParams: NavParams,
              private camera: Camera,
              private vision: GoogleCloudVisionServiceProvider,
              public history: ScansHistoryProvider,
              private alert: AlertController  
            ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AnprPage');
  }

  back(){
    this.navCtrl.pop();
  }
  
  showAlert(message) {
    let alert = this.alert.create({
      title: 'Mensaje',
      subTitle: message,
      buttons: ['OK']
    });
    alert.present();
  }

  takePhoto() {
    const options: CameraOptions = {
      quality: 40,
      targetHeight: 300, //500
      targetWidth: 300,  //500
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG, //PNG,
      mediaType: this.camera.MediaType.PICTURE
    }

    this.camera.getPicture(options)
      .then( 
        (imageData) => {

          this.vision.getText(imageData).subscribe(
            (results) => {
              this.saveResults(imageData, results);
            }, 
            err => { this.showAlert('Error 1: '+err); }
          );

        }, 
        err => { this.showAlert('Error 2: '+err); }
    );
  }

  saveResults(imageData, results) {
    let json = results.json();
    let responses: JSON = json["responses"][0];
    let textAnnotation: JSON = responses["fullTextAnnotation"];
    this.anprRes=textAnnotation['text'];
    this.history.push('anprs',this.anprRes);
  /*
      func analyzeResults(_ dataToParse: Data) {
        
        // Update UI on the main thread
        DispatchQueue.main.async(execute: {
            
            
            // Use SwiftyJSON to parse results
            let json = JSON(data: dataToParse)
            let errorObj: JSON = json["error"]
            
            
            // Check for errors
            if (errorObj.dictionaryValue != [:]) {
                self.textResults.text = "Error code \(errorObj["code"]): \(errorObj["message"])"
            }
            // Else, if success, parse the response
            else {
                print(json)
                let responses: JSON = json["responses"][0]
                
                // Get full text annotation
                let textAnnotation: JSON = responses["fullTextAnnotation"]
                print("fullTextAnnotation:")

                if textAnnotation != JSON.null  {
                    print(textAnnotation)
                    let text = textAnnotation["text"].stringValue
                    let forbiddenChars = ["|","-",".",",","\n"," "]
                    let cForbidden: Int = forbiddenChars.count
                    var result = text.trimmingCharacters(in: ["|","-",".",",","\n"," "])
                    for index in 0..<cForbidden {
                        result = result.replacingOccurrences(of: forbiddenChars[index], with: "")
                    }
                    self.textResults.text = result
                    print(text)
                }
                else {
                    self.textResults.text = ""
                    print("No text found")
                }
                
            }
        })
        
    }
  */
  }

  mockTest() {
    this.vision.mockRequest().subscribe(
      (results) => {
        let json = results.json();
        let responses: JSON = json["responses"][0];
        let textAnnotation: JSON = responses["fullTextAnnotation"];
        console.log('resultado: '+textAnnotation['text']);
        this.anprRes=textAnnotation['text'];
      }, 
      err => { this.showAlert('Error 1: '+err); }
    );   
  }
  

}



// WEBPACK FOOTER //
// ./src/pages/anpr/anpr.ts